import React, { useRef, useState } from 'react';
import { useClickAway } from 'ahooks';
import { IDatePickerProps } from '../interface/datePicker';
import { CalendarDaysHeader, CalendarDaysFooter, CalendarDays } from '../components';
import { IDatePickerValue, IFooterButItemInfo } from '../interface';
import { classSet } from '@umu/umu-dom';
import { defaultFooterList } from '../utils/picker';
import './index.scss';

const DatePicker = (props: IDatePickerProps) => {
  const { placeholder = '', defaultValue = [], hideFooter = false, initCalendarInfo, suffixIcon, format, onChange, disabledDate } = props;
  const calendarDiv = useRef<HTMLDivElement>(null);
  const [value, setValue] = useState<IDatePickerValue>(defaultValue);
  const [isShowCalendar, setIsShowCalendar] = useState<boolean>(false);
  useClickAway(() => {
    onCancelCalendar();
  }, calendarDiv);
  const onShowCalendar = () => {
    setIsShowCalendar(true);
    setValue(defaultValue);
  }
  const onCancelCalendar = () => {
    setIsShowCalendar(false);
    setValue([]);
  }
  const onFooterClick = (item: IFooterButItemInfo) => {
    if (item.key === 'submit') {
      onChange && onChange(value);
    }
    if (item.key === 'clear') {
      setValue([]);
      onChange && onChange([]);
    }
    onCancelCalendar();
  }

  const onDateListChange = (value: IDatePickerValue) => {
    setValue(value);
    if (hideFooter) {
      onChange && onChange(value);
    }
  }
  const renderCalendarBody = () => {
    if (!isShowCalendar) {
      return <></>
    }
    return <div className='umu-design-date-picker-calendar-days'>
      <CalendarDays value={value} initCalendarInfo={initCalendarInfo} onChange={onDateListChange} disabledDate={disabledDate} />
      <div className={classSet({
        'calendar-days-footer': true,
        'calendar-days-footer-hide': hideFooter
      })}>
        <CalendarDaysFooter list={defaultFooterList} onClick={onFooterClick} />
      </div>
    </div>
  }
  return (
    <div className='umu-design-date-picker-panel' ref={calendarDiv}>
      <CalendarDaysHeader
        placeholder={placeholder}
        format={format}
        isOpen={isShowCalendar}
        value={value}
        suffixIcon={suffixIcon}
        onClick={() => !isShowCalendar ? onShowCalendar() : onCancelCalendar()}
        onClearClick={() => setValue([])}
      />
      {renderCalendarBody()}
    </div>
  );
}

export {
  DatePicker
};
